import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export default makeStyles(({ spacing, palette }: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '250px',
  },
  errorText: {
    paddingLeft: '14px',
    paddingTop: '4px',
    color: palette.primary.main,
    fontSize: '0.75rem',
  },
  dragContainer: {
    backgroundColor: '#6B6B6E',
    display: 'flex',
    padding: spacing(2),
    width: '100%',
    height: '100%',
  },
  dragArea: {
    border: '2px dotted #E1E8F6',
    borderRadius: '10px',
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing(2),
  },

  dragAreaError: {
    borderColor: `${palette.primary.main} !important`,
  },

  dragging: {
    border: '2px dotted #E1E8F6',
    borderRadius: '10px',
    padding: '16px',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    background: palette.neutral[200],
  },
  defaultContent: {
    width: '100px',
    height: '105px',
    backgroundSize: 'cover',
    margin: '22px auto',
  },
  preview: {
    width: '100%',
    height: '100%',
    borderRadius: 'inherit',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    cursor: 'pointer',
    position: 'relative',

    '& > div:first-child': {
      width: '100%',
      height: '100%',
      display: 'none',
      borderRadius: '10px',
      position: 'absolute',
      background: palette.neutral[500],
      opacity: '0.8',
    },

    '&:hover > div:first-child': {
      display: 'flex !important',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },

  document: {
    color: palette.neutral[100],
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
    gap: spacing(1),
  },

  documentName: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',

    '& > div:first-child': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },

  helpText: {
    margin: '4px 0px',
    color: '#BBC1CC',
    fontWeight: 700,
  },
  link: {
    color: '#BBC1CC',
    fontWeight: 700,
    fontFamily: 'Gilroy',
    textDecoration: 'underline',
    verticalAlign: 'baseline',
    display: 'inline',
    cursor: 'pointer',
  },
  fileTypes: {
    margin: '4px',
    color: '#A8AEB8',
    fontWeight: 400,
  },
  icon: {
    color: '#BBC1CC',
    position: 'absolute',
    right: '25px',
    bottom: '25px',
  },
}));
